import { render } from "./ServiceTermsText.vue?vue&type=template&id=06807795&scoped=true"
import script from "./ServiceTermsText.vue?vue&type=script&lang=js"
export * from "./ServiceTermsText.vue?vue&type=script&lang=js"

import "./ServiceTermsText.vue?vue&type=style&index=0&id=06807795&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06807795"]])

export default __exports__